import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AddressResource } from '@data/address/address.model';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressComponent {
  @Input() address: AddressResource;
}
